import { requestCDN } from "../../apis";

export const apiGetPortal = (params) => {
  const millis = Date.now();
  return requestCDN("get", `/CNY/domain_management_landing.json?v=${millis}`);
  // return requestGlobalSettingData("get", `/setting`, params, false, false);
};
